export const isGalileoSystem = (system?: string | null) =>
  system === "GALILEO_NDC" || system === "GALILEO"
